// @flow
import type {EventHandler, EventType} from "../index";
import store from "../../../configureStore";
import {DMS_ORDER_GET_BY_ID} from "../../action";

export const OrderErrorEventHandler: EventHandler = {
	handles(eventType: EventType): boolean {
		return eventType === "ORDER_ERROR";
	},
	handle() {
		store.dispatch({
			type: DMS_ORDER_GET_BY_ID.NOT_FOUND
		});
	}
};
